import ApiBase from './base/ApiBase'


export default class AssessmentPeriodClient extends ApiBase {
    private controllerName: string = 'AssessmentPeriod';
    
    async CreateAssessmentPeriod(dto: CreateAssessmentPeriod, signal?: AbortSignal): Promise<string> {
        return this.PostAsync(`${this.controllerName}`, dto, signal);
    }

    async DeleteAssessmentPeriod(id: string, signal?: AbortSignal): Promise<void> {
        return this.DeleteAsync(`${this.controllerName}/${id}`, signal);
    }

    async GetAssessmentPeriods(signal?: AbortSignal): Promise<AssessmentPeriod[]> {
        return this.GetAsync(`${this.controllerName}`, signal);
    }
}

export interface CreateAssessmentPeriod {
    StartDate: string,
    EndDate: string
}

export interface AssessmentPeriod {
    Id: string,
    OrganizationId: string,
    StartDate: any,
    EndDate: any
}

export enum AssessmentPeriodErrors {
    CreateAssessmentPeriod = 'Error creating Assessment Period',
    DeleteAssessmentPeriod = 'Error deleting Assessment Period',
    GetAllAssessmentPeriod = 'Error loading Assessment Periods',
    GetSingleAssessmentPeriod = 'Error loading Assessment Period',
    UpdateAssessmentPeriod = 'Error saving Assessment Period',

}